import React from 'react';
import { Box, Typography } from '@mui/material';
import TooltipInstructions from './tooltip-instructions';

interface Props {
  id: string;
  LABEL: string;
  INSTRUCTIONS: Array<string>;
}

function InputLabel({ LABEL, INSTRUCTIONS, id }: Props) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
      }}
    >
      <Typography fontSize={14}>{LABEL}</Typography>
      {INSTRUCTIONS.length ? (
        <TooltipInstructions cssId={id} instructions={INSTRUCTIONS} />
      ) : null}
    </Box>
  );
}

export default InputLabel;
